import { createFileRoute } from "@tanstack/react-router";

import { PRIVACY_BLOCKS } from "@/lib/legal-privacy";

export const Route = createFileRoute("/privacy")({
  staticData: { sitemap: true },
  head: () => ({
    meta: [
      { title: "Datenschutzerklärung — Foreign Council On Economic Relations" },
      {
        name: "description",
        content:
          "Datenschutzerklärung: Art, Umfang und Zweck der Verarbeitung personenbezogener Daten im Rahmen unseres Onlineangebotes nach DSGVO.",
      },
      { property: "og:title", content: "Datenschutzerklärung — Foreign Council" },
      {
        property: "og:description",
        content: "Informationen zur Verarbeitung personenbezogener Daten nach DSGVO.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <section className="bg-surface">
      <div className="mx-auto w-full max-w-[900px] px-5 py-16 lg:px-8 lg:py-20">
        <h1 className="fc-h2 fc-rule text-foreground">Datenschutz</h1>

        <div className="mt-10 bg-card p-6 lg:p-10">
          {PRIVACY_BLOCKS.map((block, index) =>
            block.t === "h" ? (
              <h2
                key={index}
                className={`fc-h3 text-foreground ${index === 0 ? "" : "mt-10"}`}
              >
                {block.x}
              </h2>
            ) : (
              <p key={index} className="mt-4 fc-body break-words text-muted-foreground">
                {block.x}
              </p>
            ),
          )}
        </div>
      </div>
    </section>
  );
}
